import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';

import { ConfigService, ThemeConfig } from '../../core';
import { NotificationService } from '../../core/services';
import { LanguageSwitcherComponent } from '../../components/language-switcher/language-switcher.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatFormFieldModule,
    MatInputModule,
    MatBadgeModule,
    MatDividerModule,
    LanguageSwitcherComponent
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() showMenuButton = false;
  @Input() currentTheme: ThemeConfig | null = null;
  @Output() menuClick = new EventEmitter<void>();
  @Output() themeToggle = new EventEmitter<void>();

  appName$!: Observable<string>;
  userPreferences$!: Observable<any>;
  unreadCount$!: Observable<number>;

  constructor(
    private configService: ConfigService,
    private notificationService: NotificationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.appName$ = new Observable(observer => {
      observer.next(this.configService.getAppDisplayName());
    });

    this.userPreferences$ = this.configService.userPreferences$;
    this.unreadCount$ = this.notificationService.unreadCount$;

    // Prime the unread badge once on shell load (cheap; phone-scoped, cached in the service state).
    this.notificationService.refresh();
  }

  onMenuClick(): void {
    this.menuClick.emit();
  }

  onThemeToggle(): void {
    this.themeToggle.emit();
  }

  onUserMenuClick(): void {
    // TODO: Implement user menu functionality
  }

  onNotificationsClick(): void {
    this.router.navigate(['/ih-notifications']);
  }

  onSearchFocus(): void {
    // TODO: Implement search functionality
  }
}